import { render, staticRenderFns } from "./DeletePersonelDialog.vue?vue&type=template&id=630984e6"
import script from "./DeletePersonelDialog.vue?vue&type=script&lang=ts"
export * from "./DeletePersonelDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports